import firebase from 'firebase'
import User from "./user.model";
import { AppService } from '../app.service';
import { UUID } from '../../util/prototypes';
import { CustomClass } from './custom-class.model'



export class BorderRadius extends CustomClass {

    constructor(payload) {
        super(payload);
        if (payload) {
            this.topLeft = payload.topLeft;
            this.topRight = payload.topRight;
            this.bottomLeft = payload.bottomLeft;
            this.bottomRight = payload.bottomRight;
        } else {
            this.topLeft = 0;
            this.topRight = 0;
            this.bottomLeft = 0;
            this.bottomRight = 0;
        }
    }

    get style() {
        return `${this.topLeft}px ${this.topRight}px ${this.bottomLeft}px ${this.bottomRight}px`;
    }


    get className() {
        return `.${this.name}{border-radius:${this.style}}`;
    }

    static list(callback) {
        AppService.allBorderRadius((snapshot) => {
            this.snapshot = snapshot;
            const list = [];
            snapshot.docs.forEach((item) => {
                const data = item.data();
                list.push(new BorderRadius({ ...data, doc: item }))
            })
            callback(list);
        });
    }

    static loadBorderRadiusToDom(callback) {
        const stylsheet = document.createElement("style");
        stylsheet.setAttribute("type", "text/css");
        stylsheet.setAttribute("id", "borderRadius");
        BorderRadius.list((list) => {
            const css = list.map((item) => item.className).join(' ');
            stylsheet.innerText = css;
            document.querySelector("head").appendChild(stylsheet);
            callback(list);
        })
    }

    async create() {
        try {
            const data = {
                ...this.toJson(),
                name: `br-${this.name.toLowerCase()}`,
                timestamp: this.timestamp,
                uid: this.user.uid,
            };
            const resp = await AppService.addBorderRadius(data);
            this.doc = resp;
            return this;
        } catch (error) {
            console.error("Error in BorderRadius.create", error);
            throw error;
        }
    }

}